import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import { VideoQuic } from "./components/video/VideoQuic";

export const VideoTest = () => {
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );
  const [showVideo, setShowVideo] = useState(true);
  const [tailNumber, setTailNumber] = useState("1000");
  const [error, setError] = useState(false);
  const [videoKey, setVideoKey] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleVideo = () => {
    setShowVideo((prev) => !prev);
  };

  const handleTailNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // Allow only digits and length up to 4
    if (/^\d{0,4}$/.test(value)) {
      setTailNumber(value);
      setError(value.length !== 4);
      
      // If we have a valid 4-digit number, regenerate the key to force video reinitialization
      if (value.length === 4) {
        setVideoKey(Date.now());
      }
    }
  };

  // Use the tail number only if it's valid (4 digits)
  const getVideoAddresses = () => {
    const validTailNumber = tailNumber.length === 4 ? tailNumber : "1000";
    return [`e${validTailNumber}-sim1.m4mga3.com`, `e${validTailNumber}-sim2.m4mga3.com`];
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      sx={{
        height: "100vh",
        width: "100vw",
        overflowY: "auto",
        backgroundColor: "gray",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 1,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          padding: 2,
          borderRadius: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body1" sx={{ fontWeight: "medium", color: "black" }}>
            MNA-
          </Typography>
          <TextField
            label="Tail number"
            value={tailNumber}
            onChange={handleTailNumberChange}
            variant="outlined"
            size="small"
            error={error}
            helperText={error ? "Must be exactly 4 digits" : ""}
            placeholder="1000"
            inputProps={{
              maxLength: 4,
              pattern: "[0-9]*",
              inputMode: "numeric",
              style: { color: 'black' },
            }}
            sx={{ width: 150 }}
          />
        </Box>
      </Box>

      <Button
        variant="contained"
        onClick={toggleVideo}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          zIndex: 10,
        }}
      >
        {showVideo ? "Hide Video" : "Show Video"}
      </Button>

      {showVideo && (
        <Box 
          sx={{
            position: "relative",
            width: "100%",
            height: "calc(100vh - 80px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          <Box
            sx={{
              width: "auto", 
              height: "auto",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <VideoQuic
              key={videoKey}
              ipAddresses={getVideoAddresses()}
              uavId={tailNumber}
            />
          </Box>
        </Box>
      )}

      <Typography
        variant="h4"
        align="center"
        sx={{ marginTop: 2, color: "white" }}
      >
        {currentTime}
      </Typography>
    </Box>
  );
};
